module.exports = {"id":"214874","name":"Marcos Bolados","rating":"71","photo":"./data/images/photos/3/214874.png","club":{"name":"Uni. Católica","logo":"./data/images/clubs/Uni.Catolica.png"},"positions":["MC","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcosBolados0.json
// module id = 2757
// module chunks = 0